import React, { useState, useEffect, useRef } from "react";
import Grid from "@mui/material/Grid2";

import { 
  Campaign,
} from "@dndModels";

import API from "@utilities/smart_api";

import FlexBox from "@components/layout/FlexBox";
import CheckBox from "@components/input/CheckBox";
import AddButton from "@components/input/buttons/icon_buttons/AddButton";
import CampaignInput from "./CampaignInput";

const api = API.getInstance();

interface Props {}

export default function CampaignsInput({ }: Props) {
  const [reloading, setReloading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [archives, setArchives] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  if (api.user) {
    return (
      <FlexBox direction="column">
        { api.user && 
          <FlexBox direction="row">
            <FlexBox xs_expand={0} className="header centered">
              Campaigns
            </FlexBox>
            <FlexBox xs_expand={0} className="padded">
              <AddButton
                fab
                disabled={ processing || !api.online } 
                onClick={ async () => {
                  if (api.user) {
                    setProcessing(true);
                    const new_obj = new Campaign();
                    new_obj.owner_id = api.user._id;
                    const res = await api.createObject("campaign", new_obj);
                    if (res && res.body.id) {
                      api.user.owned_campaigns.push(new_obj);
                      api.user.owned_campaign_ids.push(new_obj._id);
                    } else {
                      console.log(res);
                    }
                    setProcessing(false);
                  }
                }}
              />
            </FlexBox>
            <FlexBox xs_expand={0} className="centered">
              <CheckBox
                name="View Archives"
                value={archives}
                onChange={setArchives}
              />
            </FlexBox>
          </FlexBox>
        }
        { !reloading && 
          <>
            <FlexBox>
              <Grid container spacing={0} direction="row">
                { api.user.my_campaigns.filter(o => o.archived === archives).map(campaign => {
                  return (
                    <Grid size={{ xs:12, sm: 6, md: 4, lg: 3 }} key={campaign._id}>
                      <CampaignInput
                        campaign={campaign} 
                        onUpdated={() => { setReloading(true); }}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </FlexBox>
          </>
        }
      </FlexBox>
    ); 
  } else {
    return <></>;
  }
}
